import {
  collection,
  doc,
  getDoc,
  DocumentSnapshot,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import FirebaseFirestore from '../../../services/FirebaseFirestore';

export interface OAuthClientData {
  client_id?: string;
  client_id_issued_at?: number;
  client_name?: string;
  client_uri?: string;
  logo_uri?: string;
  redirect_uris?: string[];
  scope?: string;
  contacts?: string[];
  tos_uri?: string;
  policy_uri?: string;
  [key: string]: unknown;
}

export class McpOAuthClientModel {
  constructor({
    id,
    clientData,
    expiresAt,
  }: {
    id: string;
    clientData: OAuthClientData;
    expiresAt: number;
  }) {
    this.id = id;
    this.clientData = clientData;
    this.expiresAt = expiresAt;
  }

  id: string;
  clientData: OAuthClientData;
  expiresAt: number;

  isExpired(): boolean {
    return Date.now() > this.expiresAt;
  }

  /* eslint-disable-next-line */
  static fromJson(id: string, json: { [key: string]: any }): McpOAuthClientModel {
    return new McpOAuthClientModel({
      id,
      clientData:
        typeof json?.clientData === 'object' && json.clientData !== null
          ? (json.clientData as OAuthClientData)
          : {},
      expiresAt: typeof json?.expiresAt === 'number' ? json.expiresAt : 0,
    });
  }

  /* eslint-disable-next-line */
  toJson(): { [key: string]: any } {
    return {
      clientData: this.clientData,
      expiresAt: this.expiresAt,
    };
  }

  static parent = collection(
    FirebaseFirestore,
    'mcpOAuthClients'
  ).withConverter<McpOAuthClientModel>({
    toFirestore: (model: McpOAuthClientModel) => model.toJson(),
    fromFirestore: (snapshot: QueryDocumentSnapshot) =>
      McpOAuthClientModel.fromJson(snapshot.id, snapshot.data()),
  });

  static withId = (
    id: string
  ): Promise<DocumentSnapshot<McpOAuthClientModel>> =>
    getDoc(doc(McpOAuthClientModel.parent, id));
}
